import { useEffect } from 'react';

import { useAuth } from '../auth/AuthProvider.tsx';
import { startSyncScheduler } from './engine.ts';

/**
 * Runs the sync scheduler for as long as someone is signed in.
 *
 * It renders nothing and blocks nothing. If the server is unreachable for a
 * week the app carries on exactly as it does now — entries are written to
 * Dexie and the outbox waits. That is the whole point of the local-first
 * design, and it is why this is a background effect rather than anything the
 * screens await.
 */
export function SyncProvider({ children }: { children: React.ReactNode }) {
  const { status, user } = useAuth();
  const userId = status === 'authenticated' ? (user?.id ?? null) : null;

  useEffect(() => {
    if (userId === null) return;
    return startSyncScheduler(userId);
  }, [userId]);

  return <>{children}</>;
}
